import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQ {
  question: string;
  answer: string;
}
const faqs: FAQ[] = [{
  question: 'What is included in the 2 Weeks Free trial?',
  answer: 'You get full access to our beginner classes, a uniform consultation, and a personal introduction to our school. This gives you the opportunity to experience our training environment and instruction firsthand.'
}, {
  question: 'Who can participate in the 2 Weeks Free trial?',
  answer: 'The trial is open to new students interested in martial arts training. We welcome individuals and families looking to explore what Che Ko Martial Arts has to offer.'
}, {
  question: 'Do I need prior martial arts experience?',
  answer: 'No prior experience is required. Our programs are designed to accommodate students at all levels, from complete beginners to those with previous training. Our instructors will meet you where you are and guide your development.'
}, {
  question: 'What should I wear to my first class?',
  answer: "Wear comfortable athletic clothing that allows you to move freely. During your uniform consultation, we'll provide specific details about training attire and equipment."
}, {
  question: 'How do students choose a location?',
  answer: 'Students select their preferred training location based on convenience and accessibility. Each of our locations offers quality instruction in a welcoming environment.'
}, {
  question: 'How do class schedules work?',
  answer: 'Class schedules vary by location and program. Once you select a location, our staff will provide you with detailed schedule information and help you find classes that fit your availability.'
}, {
  question: 'What styles are taught at Che Ko Martial Arts?',
  answer: 'We teach Taekwondo, Tang Soo Do, Brazilian Jiu-Jitsu, Bo Staff / Weapons training, and offer a Competition Team for advanced students. Program availability may vary by location.'
}];
export function FAQList() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 bg-white" data-id="element-118">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="space-y-4" data-id="element-120">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden transition-shadow hover:shadow-md" data-id="element-121">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-[#dc2626] focus:ring-offset-2 rounded-xl" aria-expanded={openIndex === index} data-id="element-122">
                <span className="text-lg font-bold text-[#1a2332] pr-4" data-id="element-123">
                  {faq.question}
                </span>
                <ChevronDown className={`h-5 w-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-124" />
              </button>

              {openIndex === index && <div className="px-6 pb-5 pt-2 border-t border-slate-100 animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-125">
                  <p className="text-slate-600 leading-relaxed" data-id="element-126">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}